import { render, staticRenderFns } from "./SettingsHeader.vue?vue&type=template&id=31c4ab98"
import script from "./settings-header.js?vue&type=script&lang=js&external"
export * from "./settings-header.js?vue&type=script&lang=js&external"
import style0 from "./settings-header.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports